const $ = window.jQuery;
const $window = window.$window || $(window)

const wsFormEvents = {

    init () {

        $(document).on('wsf-submit-before-ajax', (e, form, form_id, instance_id) => {
            alert('Event type: ' + e.type + " fired.\nForm ID " + form_id + ', instance ID ' + instance_id);
            // Get jQuery form object
            var form_obj = $('#ws-form-' + instance_id);
            // Get form DOM element
            var form_element = form_obj[0];
            // Get FormData object from form element
            var form_data = new FormData(form_element);
        });

    }
};

export default wsFormEvents;
